import List from '../views/categories/list'

export default [
    {
        path: '/admin/project/:project_id/categories',
        name: 'categories',
        component: List,
    }
]
